import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import dynamic from "next/dynamic";
import CustomSkeleton from "../components/CustomSkeleton/CustomSkeleton";
import FivaLayout from "../Layout/FivaLayout";
var DynamicBillPage = dynamic(function() {
    return import("../components/_SupplyForm/UploadPage/UploadPage");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("../components/_SupplyForm/UploadPage/UploadPage")
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ _jsx(CustomSkeleton, {});
    }
});
var BillPage = function() {
    var headerProps = {
        title: "Comparador de Tarifas de Luz",
        keywords: "Comparador de Tarifas, Luz El\xe9ctrica, Energ\xeda, Medio Ambiente, Software, Autoconsumo, Tecnolog\xeda de Energ\xeda Renovable, Monitoreo de Energ\xeda, Gesti\xf3n de Energ\xeda, Sostenibilidad",
        content: "Explora nuestro comparador de tarifas el\xe9ctricas, te ayudamos a encontrar la mejor opci\xf3n para tu consumo y necesidades. Contrataci\xf3n 100% online. Nuestra plataforma combina tecnolog\xeda de energ\xeda renovable, software avanzado y un enfoque en la sostenibilidad para ofrecerte una soluci\xf3n eficiente y amigable con el medio ambiente."
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: false,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(DynamicBillPage, {})
        ]
    });
};
export default BillPage;
